import React, { useState, useEffect } from 'react'
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
import SelectField from '../utils/SelectMUI'
import Pagination from '@mui/material/Pagination';
import NodataImage from '../../../../../images/nodata.png';
import { getDocConfigByPageEntryLicenseNumberProduct, getDocConfigCountByLicenseNumberProduct, DeleteDocConfigById } from './ActionCreator';


const itemsPerPage = 10;

const ProductArr = [
    { name: 'USER', code: 'USER' },
    { name: 'COMMUNITY', code: 'COMMUNITY' },
]

export default function List({ handleEdit }) {
    const [loader, setLoader] = useState(false)
    const [selectedFilter, setSelectedFilter] = useState('')
    const [tableData, setTableData] = useState([])
    const [currentPage, setcurrentPage] = useState(1);
    const [showPopup, setShowPopup] = useState({ show: false, popupStatus: "" })
    const [totalcount, settotalcounts] = useState(0)
    const inputChange = (e, type) => {
        setSelectedFilter(e)
      
    }


    const actionHandler = (type, data) => {
        if (type == "delete") {
            setLoader(true)
            DeleteDocConfigById(data?.id,callback=>{
                setLoader(false)
                if(callback == "success"){
                    setShowPopup({show:true,popupStatus:"Data Deleted Successfully"})
                    GetDocListAPI(1, selectedFilter)
                    GetDocListCountAPI(selectedFilter)
                }else{
                    setShowPopup({show:true,popupStatus:'Error Deleting Data'})
                }
                removePopup();
            })
        }
        else if (type === "edit") {
            handleEdit(data)
        }
        else if (type === "search") {
            setcurrentPage(1)
            GetDocListAPI(1, selectedFilter)
            GetDocListCountAPI(selectedFilter)
        }
    }



    useEffect(() => {
        GetDocListAPI(1, selectedFilter)
        GetDocListCountAPI(selectedFilter)
    }, [])

    const GetDocListAPI = (page, filter) => {
        setLoader(true)
        getDocConfigByPageEntryLicenseNumberProduct(page, itemsPerPage, filter, callBack => {
            setLoader(false)
            console.log("call", callBack)
            if (callBack && callBack?.length > 0) {
                setTableData(callBack)
            } else {
                setTableData([])
            }
        })
    }
    const GetDocListCountAPI = (filter) => {
        setLoader(true)
        getDocConfigCountByLicenseNumberProduct(filter, (callBack) => {
            setLoader(false)
            console.log("call", callBack)
            if (callBack) {
                settotalcounts(callBack)
            } else {
                settotalcounts(0)
            }
        })
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
        GetDocListAPI(value, selectedFilter)
        GetDocListCountAPI(selectedFilter)
    }

    const concatenatedString = (data) => {
        let str = "";
        data?.map(value => {
            str = str?.length > 0 ? str + ", " + value : value
        })
        
        return str
    }

    const closePopup=()=>{
        setShowPopup({show:false,popupStatus:''})
    }

    const removePopup=()=>{
        setTimeout(()=>{
            closePopup()
        },5000)
    }


    return (
        <>
            {loader ? <Loader /> : ''}
            {
                showPopup?.show ?
                    <Popup popupStatus={showPopup?.popupStatus} closePopup={closePopup} />
                    : ''}
            <div className="container-fluid" style={{ marginTop: '50px' }}>


                <div className="row">
                    <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                        <SelectField
                            label={'Product'}
                            onChange={e => inputChange(e, 'product')}
                            id="product"
                            value={selectedFilter}
                            name="Product"
                            data={ProductArr}
                            size={'small'}
                            required={false}
                        />
                    </div>
                    <div className="col-sm-1 col-xs-6" style={{ marginTop: '10px' }}>
                        <div className='btn-group' style={{ display: 'flex' }}>
                            <button
                                className='cred-btn center-block mr-3'
                                onClick={e => actionHandler('search', "")}
                                style={{ padding: '10px 15px', background: '#064254', borderRadius: '8px', border: '1px solid #064254' }}><i style={{ fontSize: '16px' }} className='fa fa-search' /></button>


                        </div>
                    </div>

                    <div className="col-xs-12" style={{ marginTop: '30px' }}>
                        <div className='table-responsive full-height'>
                            {tableData?.length > 0 ?
                                <>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='table credhub-table'>
                                            <thead>
                                                <tr>
                                                    <th scope="col">Document Name</th>
                                                    <th scope='col'>Product</th>
                                                    <th scope="col">Type</th>
                                                    <th scope="col">Document Types Allowed</th>
                                                    <th scope="col">Mandatory</th>
                                                    <th scope="col">Status Code</th>
                                                    <th scope="col">Size</th>
                                                    <th scope="col">Edit</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableData?.map((row, i) => {
                                                    return (
                                                        <tr key={i}>


                                                            <td>{row?.name || "-"}</td>
                                                            <td>{row?.product || "-"}</td>
                                                            <td>{row?.type || "-"}</td>
                                                            <td>{row?.docTypesAllowed?.length > 0 ? concatenatedString(row?.docTypesAllowed) : '-'}</td>
                                                            <td>{row?.mandatoryOrNot == false ? "NO" : row?.mandatoryOrNot == true ? "YES" : ''}</td>
                                                            <td>{row?.statusCode || "-"}</td>
                                                            <td>{row?.sizeLimit || "-"}</td>
                                                            <td>
                                                                <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                    <i className='fa fa-edit' />
                                                                </button>
                                                                <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                    <i className='fa fa-trash-o' />
                                                                </button>
                                                            </td>
                                                            {/* : ""} */}
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                    <Pagination
                                        count={Math.ceil(totalcount / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="success" variant="outlined" shape="rounded"
                                        style={{ display: 'flex', justifyContent: 'end' }}
                                    />
                                </>
                                :
                                <p style={{ marginTop: '100px' }} className="text-center">
                                    <img src={NodataImage} style={{ width: '30%' }} alt="No data available" />
                                </p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
